import { getImageFilePreview } from '../../../../utils/file'
import { FilePreview } from '../../../File'
import { useWidgetContentFileItemHandlers } from '../WidgetContentFiles.hooks'
import { WidgetContentFilesImagesListItemOverlay } from '../WidgetContentFilesImagesListItemOverlay'

import * as styles from './WidgetContentFilesImagesListItem.module.css'

function WidgetContentFilesImagesListItem({
  ErrorPreviewImageOverlay = WidgetContentFilesImagesListItemOverlay,
  Overlay = WidgetContentFilesImagesListItemOverlay,
  allowRemove = false,
  className = styles.WidgetContentFilesImagesListItem,
  file,
  getImageSrc = getImageFilePreview,
  scope,
  onClick,
  onSuccessDownloadFile,
  ...restProps
}) {
  const { handleClick, handleClickDownloadFile, loading } =
    useWidgetContentFileItemHandlers({
      file,
      scope,
      onClick,
      onSuccessDownloadFile,
    })

  const downloadFileProps = {
    loading,
    onClickDownloadFile: handleClickDownloadFile,
  }

  return (
    <FilePreview
      {...restProps}
      ErrorPreviewImageOverlay={ErrorPreviewImageOverlay}
      Overlay={Overlay}
      allowRemove={allowRemove}
      className={className}
      disabled={loading}
      errorImagePreviewProps={downloadFileProps}
      file={file}
      getImageSrc={getImageSrc}
      overlayProps={downloadFileProps}
      onClick={handleClick}
    />
  )
}

export default WidgetContentFilesImagesListItem
